import { COPY_KEY } from '~/utils/clubConfig/types'

import { GT } from '~/lib/gt'

import { getCopy as getCzCopy } from '../cz/copy'
import { getCopy as getDeCopy } from '../de/copy'
import { getCopy as getPlCopy } from '../pl/copy'

export const getCopy = (copyKey: COPY_KEY, gt: GT) => {
  switch (copyKey) {
    case COPY_KEY.Pl:
      return getPlCopy(gt)
    case COPY_KEY.Cz:
      return getCzCopy(gt)
    case COPY_KEY.De:
      return getDeCopy(gt)
  }
}
